exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".h2JIkDKNz_fNlZ9Smtuml{width:100%;height:300px;position:relative;text-align:center}.h2JIkDKNz_fNlZ9Smtuml>._3uwPFA1IfbFytVuV1WmA6m{color:#fff;height:100%;position:absolute;top:0px;left:50%;transform:translate(-50%, 0);display:flex;flex-direction:column;justify-content:center;align-items:center}.h2JIkDKNz_fNlZ9Smtuml>._3uwPFA1IfbFytVuV1WmA6m>h2{color:#fff}.h2JIkDKNz_fNlZ9Smtuml>._3uwPFA1IfbFytVuV1WmA6m>h1{margin-bottom:0px}._1yH7iQkGtjClIQahxijuSj{width:100%;height:300px;object-fit:cover}\n", ""]);

// Exports
exports.locals = {
	"header": "h2JIkDKNz_fNlZ9Smtuml",
	"text": "_3uwPFA1IfbFytVuV1WmA6m",
	"img": "_1yH7iQkGtjClIQahxijuSj"
};